import { AbstractServiceRecord } from './abstract-service-record';
import { DataType } from '@common/enums/data-type';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';
import { IServiceCollectionRecord } from '@common/interfaces/i-service-collection-record';
import { ServiceCollectionFactory } from '@common/data-models/service/service-collection-factory';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { ListData } from './list-data';
import { ObjectProperties } from './object-properties';
import { ApiServiceRecord } from './api-service-record';

let metaData = {
    HasPendingChanges: DataType.BOOL,
    LTTRecording: DataType.BOOL,
    OnAir: DataType.BOOL,
    SuspendRowFlashing: DataType.BOOL,
    TimeFormat: DataType.NUMBER,
    UpdatesSuspended: DataType.BOOL
};

KnownPropertyTypes.setFor(metaData);

export class ApiServiceCollectionRecord extends AbstractServiceRecord implements IServiceCollectionRecord {
    public Children: Array<IServiceCollectionScript>;
    public HasPendingChanges?: boolean;
    public LTTRecording?: boolean;
    public OnAir?: boolean;
    public SuspendRowFlashing?: boolean;
    public TimeFormat?: number;
    public UpdatesSuspended?: boolean;
    public Properties: { [id: string]: any } = {};

    public getOwnMetaData(): { [id: string]: number } {
        let objectKeys = Object.keys(this);
        let ret = {};
        for (let prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getOwnMetaData();
        let parentMetaData = super.getMetaData();

        // merge
        for (let p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        } else return super.getRawValue(field);
    }

    public static instance(data: any): ApiServiceCollectionRecord {
        let ret: ApiServiceCollectionRecord = Object.assign(ServiceCollectionFactory.newApiServiceCollectionRecord(), data);
        if (ret.Children) {
            for (let i in ret.Children) {
                ret.Children[i] = Object.assign(ServiceCollectionFactory.newApiServiceCollectionScript(), ret.Children[i]);
                ret.Children[i].instantiateChildren();
            }
        }
        if (ret.LinkedRecords) {
            for (let i in ret.LinkedRecords) {
                ret.LinkedRecords[i] = Object.assign(new ApiServiceRecord, ret.LinkedRecords[i]);
                ret.LinkedRecords[i].instantiateChildren();
            }
        }
        ret.instantiateChildren();
        return ret;
    }

    public instantiateChildren() {
        this.ListData = Object.assign(new ListData(), this.Properties);
        this.ObjectPropertiesCollection = new ObjectProperties(this.Properties, true);
    }
}

ServiceCollectionFactory.newApiServiceCollectionRecord = () => {
    return new ApiServiceCollectionRecord();
};
